module.exports = __webpack_public_path__ + "img/pm2.5T.baf29619.png";